import { AlignmentType } from 'docx'
import {
  BOLD_TEXT,
  UNDERLINED_BOLD_TEXT,
  createCombinationParagraph,
} from './docxFunctions'

/** 14 pt в единицах docx (half-points). */
export const SECTION_HEADING_SIZE = 28

/**
 * Пронумерованный заголовок раздела: «N. ТЕКСТ» (текст подчёркнут), 14 pt.
 * @param {number|string} number
 * @param {string} title
 * @param {{ suffix?: string, alignment?: import('docx').AlignmentType }} [options]
 */
export function createNumberedSectionHeading(
  number,
  title,
  { suffix = ':', alignment = AlignmentType.JUSTIFIED } = {}
) {
  const size = SECTION_HEADING_SIZE
  const parts = [
    { type: BOLD_TEXT, content: `${number}. `, size },
    { type: UNDERLINED_BOLD_TEXT, content: title, size },
  ]
  if (suffix) {
    parts.push({ type: BOLD_TEXT, content: suffix, size })
  }
  return createCombinationParagraph(parts, { alignment })
}

/** Подраздел «3.1 РАСЧЕТЫ…» при нескольких показаниях. */
export function createSubsectionHeading(number, title) {
  const size = SECTION_HEADING_SIZE
  return createCombinationParagraph(
    [
      { type: BOLD_TEXT, content: `${number} `, size },
      { type: UNDERLINED_BOLD_TEXT, content: title, size },
    ],
    { alignment: AlignmentType.JUSTIFIED }
  )
}
